import * as ActionTypes from "./actionTypes";

export function loadModules() {
	return { type: ActionTypes.LOAD_MODULES };
}

export function loadModulesSuccess(modules) {
	return { type: ActionTypes.LOAD_MODULES_SUCCESS, modules };
}

export function loadModulesFail(errorMessage) {
	return { type: ActionTypes.LOAD_MODULES_FAIL, errorMessage };
}
